module.exports = __webpack_public_path__ + "img/logro2.9bb4bc69.webp";